import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { boxMembersQuery } from 'networking/mindfeed/queries/boxMembers';
import type { BoxId, Member } from 'models/Box';

type QueryKeyType = [QueryKey.BOX_MEMBERS, BoxId?];

type Options = Omit<
  UseQueryOptions<Member[], unknown, Member[], QueryKeyType>,
  'queryKey' | 'queryFn'
>;

type Params = {
  boxId?: BoxId;
  options?: Options;
};

export default function useBoxMembers({ boxId, options = {} }: Params = {}) {
  // With no box id the query is defined but doesn't run (see boxMembersQuery).
  const query = useQuery({
    ...boxMembersQuery(boxId),
    placeholderData: (previousData) => previousData,
    ...options,
  });

  const canRun = !!boxId && (options?.enabled ?? true);

  return {
    ...query,
    isLoading: canRun && query.isPending,
  };
}
